// api.js
// 8010 upload ； 8000 analyze
export const API_BASE_UPLOAD_URL = 'https://625c-140-113-113-35.ngrok-free.app';
export const API_BASE_URL = 'https://90de-140-113-113-35.ngrok-free.app';